module.exports = __webpack_public_path__ + "img/boy-workout.a63df67e.gif";